import { render, staticRenderFns } from "./backCenter.vue?vue&type=template&id=619f12bd&scoped=true"
import script from "./backCenter.vue?vue&type=script&lang=js"
export * from "./backCenter.vue?vue&type=script&lang=js"
import style0 from "./backCenter.vue?vue&type=style&index=0&id=619f12bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619f12bd",
  null
  
)

export default component.exports